/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Paper } from '@mantine/core';

// Styles
import classes from './account-settings.module.css';

// UI local components
import { ProfileForm } from '@features/account-settings/components/ProfileForm';

const AccountSettings = () => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Paper className={classes.container}>
			<ProfileForm />
		</Paper>
	);
};

export default AccountSettings;
